
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';
import CampsBayPage from '../pages/camps-bay/page';
import StilbaaiPage from '../pages/stilbaai/page';
import JeffreysBayPage from '../pages/jeffreys-bay/page';
import GeorgePage from '../pages/george/page';
import WildernessPage from '../pages/wilderness/page';
import LangebaanPage from '../pages/langebaan/page';
import GreenPointPage from '../pages/green-point/page';
import SeaPointPage from '../pages/sea-point/page';
import TableViewPage from '../pages/table-view/page';
import BookPage from '../pages/book/page';

const HomePage = lazy(() => import('../pages/home/page'));
const BloubergstrandPage = lazy(() => import('../pages/bloubergstrand/page'));
const MelkbosstrandPage = lazy(() => import('../pages/melkbosstrand/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/book',
    element: <BookPage />
  },
  {
    path: '/bloubergstrand',
    element: <BloubergstrandPage />,
  },
  {
    path: '/melkbosstrand',
    element: <MelkbosstrandPage />,
  },
  {
    path: '/camps-bay',
    element: <CampsBayPage />
  },
  {
    path: '/stilbaai',
    element: <StilbaaiPage />
  },
  {
    path: '/jeffreys-bay',
    element: <JeffreysBayPage />
  },
  {
    path: '/george',
    element: <GeorgePage />
  },
  {
    path: '/wilderness',
    element: <WildernessPage />
  },
  {
    path: '/langebaan',
    element: <LangebaanPage />
  },
  {
    path: '/green-point',
    element: <GreenPointPage />
  },
  {
    path: '/sea-point',
    element: <SeaPointPage />
  },
  {
    path: '/table-view',
    element: <TableViewPage />
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
